import { Component, OnInit, Input, input, InputSignal } from '@angular/core';
import { NgApexchartsModule } from 'ng-apexcharts';

@Component({
  selector: 'report-chart',
  templateUrl: './case-details-report-charts.html',
  standalone: true,
  imports: [NgApexchartsModule],
})
export class ReportChartComponent implements OnInit {
  chartOptions: any = {};
  costReport: InputSignal<any> = input.required();
  @Input() chart!: string;
  constructor() {}

  ngOnInit(): void {
    {
      switch (this.chart) {
        case 'bar':
          this.chartOptions = {
            series: [
              {
                name: 'Cost',
                data: this.costReport().table_medical_supplies_detailed_cost.map(
                  (item: any) => {
                    return item['Price billed total'];
                  }
                ),
              },
            ],
            legend: {
              show: false,
            },
            chart: {
              height: 450,
              type: 'bar',
            },
            dataLabels: {
              enabled: false,
            },
            xaxis: {
              categories:
                this.costReport().table_medical_supplies_detailed_cost.map(
                  (item: any) => {
                    return item['Description'];
                  }
                ),
              title: {
                text: '%',
              },
              labels: {
                show: false,
              },
              axisBorder: {
                show: false,
              },
              axisTicks: {
                show: false,
              },
            },
            yaxis: {
              title: {
                text: 'Ευρώ (€)',
              },
            },
            colors: ['#125773'],
            plotOptions: {
              bar: {
                distributed: true,
                enableShades: false,
              },
            },
          };

          break;
        case 'area':
          this.chartOptions = {
            series: [
              {
                name: 'Κόστος από τιμές αναφοράς / τεμάχιο',
                data: this.costReport().table_medical_supplies_detailed_cost.map(
                  (item: any) => {
                    return item['Market price/item'];
                  }
                ),
              },
              {
                name: 'Τιμολογημένο κόστος / τεμάχιο',
                data: this.costReport().table_medical_supplies_detailed_cost.map(
                  (item: any) => {
                    return item['Price billed/item'];
                  }
                ),
              },
            ],
            chart: {
              height: 400,
              type: 'area',
              toolbar: {
                show: true, // Ensure the toolbar is shown
                tools: {
                  zoom: true,
                  zoomin: true,
                  zoomout: true,
                },
              },
            },
            dataLabels: {
              enabled: false,
            },
            stroke: {
              curve: 'smooth',
            },
            legend: {
              position: 'top',
              horizontalAlign: 'left',
            },
            yaxis: {
              title: {
                text: 'Ευρώ (€)',
              },
            },
            xaxis: {
              axisBorder: {
                show: false,
              },
              axisTicks: {
                show: false,
              },
              labels: {
                show: false,
              },
              categories:
                this.costReport().table_medical_supplies_detailed_cost.map(
                  (item: any) => {
                    return item['Description'];
                  }
                ),
            },
          };

          break;
        case 'pie':
          this.chartOptions = {
            series: this.getPieValues(),
            chart: {
              width: '100%',
              height: 450,
              type: 'donut',
            },
            stroke: {
              width: 0,
            },
            plotOptions: {
              pie: {
                donut: {
                  labels: {
                    show: true,
                    total: {
                      showAlways: false,
                      show: false,
                    },
                  },
                },
              },
            },
            labels: ['Περιθώριο Κέρδους', 'Συνολικό κόστος από τιμές αναφοράς'],
            legend: {
              show: true,
              position: 'bottom',
            },
            title: {
              text: 'Ποσοστό Υπερχρέωσης',
              align: 'center',
            },
            colors: ['#FFE5B4', '#C9C9C9'], // Gray and Yellow colors
            responsive: [
              {
                breakpoint: 480,
                options: {
                  chart: {
                    width: 200,
                  },
                  legend: {
                    position: 'bottom',
                  },
                },
              },
            ],
          };

          break;

        case 'overChangePercentage':
          this.chartOptions = {
            series: [
              {
                name: 'Διαφορά Τιμής',
                data: this.costReport().table_medical_supplies_scale_analysis.map(
                  (item: any) => {
                    return item['Percentage price difference'];
                  }
                ),
              },
            ],
            legend: {
              show: false,
            },
            chart: {
              height: 450,
              type: 'bar',
            },
            dataLabels: {
              enabled: false,
            },
            xaxis: {
              categories:
                this.costReport().table_medical_supplies_scale_analysis.map(
                  (item: any) => {
                    return item['Scale'];
                  }
                ),
              labels: {
                show: true,
              },
              axisBorder: {
                show: false,
              },
              axisTicks: {
                show: false,
              },
              // title: {
              //   text: 'Data Categories', // Add your xlabel here
              //   offsetY: 10,
              //   style: {
              //     fontSize: '12px',
              //     fontWeight: 'bold',
              //     color: '#000',
              //   },
              // },
            },
            colors: [
              '#125773',
              '#13428E',
              '#133197',
              '#1321A1',
              '#1310AB',
              '#1300B5',
            ],
            plotOptions: {
              bar: {
                distributed: true,
                enableShades: false,
              },
            },
            yaxis: {
              labels: {
                formatter: function (y: any) {
                  return y.toFixed(2) + '%';
                },
              },
              title: {
                text: 'Percentage Difference', // Add ylabel here if needed
              },
            },
          };

          break;

        case 'drugsConsumption':
          this.chartOptions = {
            series: [
              {
                name: 'Ποσότητα',
                data: this.costReport()
                  .table_medicine_detailed.map((item: any) => {
                    return item['Quantity'];
                  })
                  .sort((a: any, b: any) => {
                    // Sort in descending order
                    return b - a;
                  }),
              },
            ],
            legend: {
              show: false,
            },
            chart: {
              height: 450,
              type: 'bar',
            },
            dataLabels: {
              enabled: false,
            },
            xaxis: {
              categories: this.costReport().table_medicine_detailed.map(
                (item: any) => {
                  return item['Description'];
                }
              ),
              labels: {
                show: false,
              },
              axisBorder: {
                show: false,
              },
              axisTicks: {
                show: false,
              },
            },
            yaxis: {
              title: {
                text: 'Κατανάλωση',
              },
            },
            colors: ['#125773'],
            plotOptions: {
              bar: {
                distributed: true,
                enableShades: false,
              },
            },
          };
          break;

        case 'dummyBar':
          this.costReport().sort((a: any, b: any) => {
            return (
              b['Συνολικό τιμολογημένο κόστος'] -
              a['Συνολικό τιμολογημένο κόστος']
            );
          });
          this.chartOptions = {
            series: [
              {
                name: 'Κόστος',
                data: this.costReport().map((item: any) => {
                  return item['Συνολικό τιμολογημένο κόστος'];
                }),
              },
            ],
            legend: {
              show: false,
            },
            chart: {
              height: 450,
              type: 'bar',
            },
            dataLabels: {
              enabled: false,
            },
            xaxis: {
              categories: this.costReport().map((item: any) => {
                return item['Περιγραφή'];
              }),
              title: {
                text: '%',
              },
              labels: {
                show: false,
              },
              axisBorder: {
                show: false,
              },
              axisTicks: {
                show: false,
              },
            },
            yaxis: {
              title: {
                text: 'Ευρώ (€)',
              },
            },
            colors: ['#125773'],
            plotOptions: {
              bar: {
                distributed: true,
                enableShades: false,
              },
            },
          };

          break;
        case 'areaDummy':
          this.chartOptions = {
            series: [
              {
                name: 'Κόστος από τιμές αναφοράς / τεμάχιο',
                data: this.costReport().map((item: any) => {
                  return item['Κόστος από τιμές αναφοράς/τεμάχιο'];
                }),
              },
              {
                name: 'Τιμολογημένο κόστος / τεμάχιο',
                data: this.costReport().map((item: any) => {
                  return item['Τιμολογημένο κόστος/τεμάχιο'];
                }),
              },
            ],
            chart: {
              height: 400,
              type: 'area',
              toolbar: {
                show: true, // Ensure the toolbar is shown
                tools: {
                  zoom: true,
                  zoomin: true,
                  zoomout: true,
                },
              },
            },
            dataLabels: {
              enabled: false,
            },
            stroke: {
              curve: 'smooth',
            },
            legend: {
              position: 'top',
              horizontalAlign: 'left',
            },
            yaxis: {
              title: {
                text: 'Ευρώ (€)',
              },
            },
            xaxis: {
              axisBorder: {
                show: false,
              },
              axisTicks: {
                show: false,
              },
              labels: {
                show: false,
              },
              categories: this.costReport().map((item: any) => {
                return item['Περιγραφή'];
              }),
            },
          };

          break;

        case 'drugsConsumptionDummy':
          this.costReport().sort((a: any, b: any) => {
            // Sort in descending order
            return b['Ποσότητα'] - a['Ποσότητα'];
          });
          this.chartOptions = {
            series: [
              {
                name: 'Ποσότητα',
                data: this.costReport().map((item: any) => {
                  return item['Ποσότητα'];
                }),
              },
            ],
            legend: {
              show: false,
            },
            chart: {
              height: 450,
              type: 'bar',
            },
            dataLabels: {
              enabled: false,
            },
            xaxis: {
              categories: this.costReport().map((item: any) => {
                return item['Περιγραφή'];
              }),
              labels: {
                show: false,
              },
              axisBorder: {
                show: false,
              },
              axisTicks: {
                show: false,
              },
            },
            yaxis: {
              title: {
                text: 'Κατανάλωση',
              },
            },
            colors: ['#125773'],
            plotOptions: {
              bar: {
                distributed: true,
                enableShades: false,
              },
            },
          };
          break;

        case 'overChangePercentageDummy':
          this.chartOptions = {
            series: [
              {
                name: 'Διαφορά Τιμής',
                data: this.costReport().map((item: any) => {
                  return item['Ποσοστιαία διαφοροποίηση'];
                }),
              },
            ],
            legend: {
              show: false,
            },
            chart: {
              height: 450,
              type: 'bar',
            },
            dataLabels: {
              enabled: false,
            },
            xaxis: {
              categories: this.costReport().map((item: any) => {
                return item['Κλίμακα'];
              }),
              labels: {
                show: true,
              },
              axisBorder: {
                show: false,
              },
              axisTicks: {
                show: false,
              },
            },
            colors: [
              '#125773',
              '#13428E',
              '#133197',
              '#1321A1',
              '#1310AB',
              '#1300B5',
            ],
            plotOptions: {
              bar: {
                distributed: true,
                enableShades: false,
              },
            },
            yaxis: {
              labels: {
                formatter: function (y: any) {
                  return y.toFixed(2) + '%';
                },
              },
              title: {
                text: 'Percentage Difference', // Add ylabel here if needed
              },
            },
          };

          break;
      }
    }
  }

  getPieValues(): number[] {
    let list: number[] = [];

    // Calculate the absolute difference and add to the list
    let billedTotal =
      this.costReport().table_medical_supplies_aggregated[0][
        'Price billed total'
      ];
    let marketTotal =
      this.costReport().table_medical_supplies_aggregated[0][
        'Market price total'
      ];
    let value: number = Math.abs(billedTotal - marketTotal);
    value = Number(value.toFixed(2));
    list.push(value, marketTotal);
    return list;
  }
}
